// extracted by mini-css-extract-plugin
export default {"fit":"analisis_fit__vAvn3"};